import { COLOR_PALETTE, COLOR_PALETTE_CONTRAST, DATA_VISUALIZATION_HUE_SEQUENCE, DATA_VISUALIZATION_DEFAULTS, CHART_TYPE, DATA_VISUALIZATION_HUE_VARIANT, DATA_VISUALIZATION_HUE } from '../constants';
import { IChartSeries, IChartColor } from '../models';

const getDataVisualizationColorsInSequence = (
  noOfColors: number,
  palette: COLOR_PALETTE,
  contrast: COLOR_PALETTE_CONTRAST = DATA_VISUALIZATION_DEFAULTS.CONTRAST,
): string[] => {
  const colorPaletteAllDefault = DATA_VISUALIZATION_HUE_SEQUENCE[COLOR_PALETTE.ALL][0][COLOR_PALETTE_CONTRAST.DEFAULT];

  if (!DATA_VISUALIZATION_HUE_SEQUENCE[palette]) {
    return colorPaletteAllDefault;
  }

  // extract palette colors
  const paletteColors = DATA_VISUALIZATION_HUE_SEQUENCE[palette];

  // extract based of number of colors required; Fall back: All colors under the palette
  const colorGroup = paletteColors[noOfColors] ?? paletteColors[0];

  // extract by contrast type; Fall back: DEFAULT
  const colors = colorGroup[contrast] ?? colorGroup[COLOR_PALETTE_CONTRAST.DEFAULT];

  // If extracted colors less than no of colors required, fall back to all colors with default contrast
  return colors.length >= noOfColors ? colors : colorPaletteAllDefault;
};

const getRequiredNumberOfColors = (chartType: CHART_TYPE, series: IChartSeries[]): number => {
  switch (chartType) {
    case CHART_TYPE.PIE:
    case CHART_TYPE.DONUT:
    case CHART_TYPE.SEMI_CIRCLE:
    case CHART_TYPE.LINE:
      return series[0]?.data.length;
    default:
      return series.length;
  }
};

const getCustomColors = (hues: string[] | DATA_VISUALIZATION_HUE_VARIANT[]): string[] => {
  return hues.map(h => getCssColorCode(h));
};

/************ Exports *****************/

/*
Hues can be enum/css color codes --> [0,1,2,...]/[#ffff, #dddd,..]
*/
export const getCssColorCode = (hue: string | DATA_VISUALIZATION_HUE_VARIANT): string => {
  if (hue in DATA_VISUALIZATION_HUE_VARIANT) {
    return DATA_VISUALIZATION_HUE[hue];
  }

  // TODO: Regex to validate the color format [#xxxx, rgba(xx, xx, xx, xx)]
  return hue.toString();
};

export const getDataVisualizationColors = (chartType: CHART_TYPE, series: IChartSeries[], color: IChartColor): string[] => {
  if (!series || series?.length === 0) {
    return [];
  }

  if (color.palette === COLOR_PALETTE.CUSTOM && color.hues?.length) {
    return getCustomColors(color.hues);
  }

  return getDataVisualizationColorsInSequence(getRequiredNumberOfColors(chartType, series), color.palette, color.contrast);
};